import { LogoSpotifyForArtists, VisuallyHidden, cssColorValue, screenMdMin, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { Link } from '../Link/Link';
import { getInternalHref } from './utils';
const S4ALogo = styled(LogoSpotifyForArtists) `
  fill: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  @media (min-width: ${screenMdMin}) {
    display: ${({ condensed }) => (condensed ? 'none' : 'block')};
  }
  @media (max-width: ${screenMdMin}) {
    display: ${({ condensed }) => (condensed ? 'block' : 'none')};
  }
`;
export const NavBarLogo = ({ headerEntry, colors }) => {
    const { isFrodor, trackCat } = useS4AMastheadContext();
    const label = headerEntry.fields.navBarLogoLabel;
    return (React.createElement(Link, { href: getInternalHref('/home/?ref=logo', isFrodor), track: [trackCat, 'Logo'], dataTestId: "navigation-logo" },
        React.createElement(S4ALogo, { colors: colors, label: label, height: 36 }),
        React.createElement(S4ALogo, { colors: colors, condensed: true, label: label, height: 28 }),
        React.createElement(VisuallyHidden, null, label)));
};
//# sourceMappingURL=Logo.js.map